import React, {memo, useState, useEffect} from "../../../__snowpack__/pkg/react.js";
import {Tag, Button, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import {formatCurrencyMoney} from "../../lib/formatter.js";
import moment from "../../../__snowpack__/pkg/moment-timezone.js";
import {IconReset} from "../../../__snowpack__/pkg/@genieui-react/icon.js";
import {eventLogger} from "../../lib/eventLogger.js";
export const TableFormTags = memo((props) => {
  const [_, forceUpdate] = useState([]);
  const {
    formData,
    getLabelIntlMessage = (label) => {
      return formatMessage({
        id: label
      });
    },
    onChange,
    resetForm,
    formatMessage,
    eventLocation,
    unCloseableTags
  } = props;
  const [tags, setTags] = useState([]);
  useEffect(() => {
    const tags2 = [];
    let filterTypeLabelKey = "";
    for (let [k, v] of Object.entries(formData)) {
      if (k === "filterType") {
        filterTypeLabelKey = v?.key;
      }
      if (k === "keyword" && !!filterTypeLabelKey) {
        k = filterTypeLabelKey;
        v = Array.isArray(v) ? v.filter((item) => !!item) : v;
      }
      if (v) {
        if (Array.isArray(v) && v.length === 0) {
        } else {
          tags2.push({key: k, value: Array.isArray(v) ? v : [v]});
        }
      }
    }
    setTags(tags2);
    forceUpdate([]);
  }, [formData]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, tags.map((tag) => /* @__PURE__ */ React.createElement("span", {
    key: tag.key
  }, /* @__PURE__ */ React.createElement("span", {
    style: {marginRight: 4},
    key: `label-${tag.key}`
  }, getLabelIntlMessage(tag.key), ":"), typeof tag.value[0] === "string" ? tag.value.map((v, i) => /* @__PURE__ */ React.createElement(Tooltip, {
    title: v,
    key: v,
    placement: "bottom"
  }, /* @__PURE__ */ React.createElement(Tag, {
    key: v + i,
    closable: !unCloseableTags?.includes(tag.key),
    style: {marginTop: 8},
    onClose: (e) => {
      onChange({key: tag.key, value: v});
    }
  }, v && v.length > 20 ? /* @__PURE__ */ React.createElement(React.Fragment, null, props.formatTagLabel ? props.formatTagLabel(tag.key, v) : /* @__PURE__ */ React.createElement(React.Fragment, null, `${v.slice(0, 30)}...`)) : /* @__PURE__ */ React.createElement(React.Fragment, null, props.formatTagLabel ? props.formatTagLabel(tag.key, v) : v)))) : moment.isMoment(tag.value[0]) || Number.isInteger(tag.value[0]) ? /* @__PURE__ */ React.createElement(Tag, {
    closable: !unCloseableTags?.includes(tag.key),
    style: {marginTop: 8},
    onClose: (e) => {
      onChange({key: tag.key});
    },
    key: tag.key
  }, moment.isMoment(tag.value[0]) && tag.value.length > 1 ? `${moment(tag.value[0]).format(props?.isDateWithTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD")}
                      -
                    ${moment(tag.value[1]).format(props?.isDateWithTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD")}` : `${formatCurrencyMoney(tag.value[0])}-${formatCurrencyMoney(tag.value[1])}`) : tag.value.map((v, i) => {
    return /* @__PURE__ */ React.createElement(Tag, {
      key: v + i,
      closable: !unCloseableTags?.includes(tag.key),
      style: {marginTop: 8},
      visible: true,
      onClose: (e) => {
        onChange({key: tag.key, value: v});
      }
    }, v.label);
  }))), tags.length > 0 ? /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    icon: /* @__PURE__ */ React.createElement(IconReset, {
      width: 12,
      height: 12,
      style: {marginRight: 1},
      primaryColor: "#6020FF"
    }),
    onClick: () => {
      eventLogger.push({
        action: "ClickClear",
        location: eventLocation
      });
      resetForm();
    }
  }, formatMessage({id: "reset"})) : /* @__PURE__ */ React.createElement(React.Fragment, null));
});
